import {
  getEncryptedPassword,
  getDecryptedPassword,
} from '@/src/utils/password'
import api from '@api'
import { transformUser } from '@data/user'
import { isPortalLogin } from '@utils/auth'
import { getRootTranslator } from '@utils/get-module-translator'
import { stringify } from '@utils/stringify-json'
import moment from 'moment'

const _getAChar = (index) => {
  const codes = [66, 97, 115, 105, 99]
  return String.fromCharCode(codes[index])
}

const _getKeyValue = (index) => {
  return (getDecryptedPassword(process.env.VUE_APP_CLIENT_ID) || '').split('_')[
    index
  ]
}

const _getChar = (index) => {
  const codes = [65, 117, 116, 104, 111, 114, 105, 122, 97, 116, 105, 111, 110]
  return String.fromCharCode(codes[index])
}

export function loginApi(
  username,
  password,
  aditionalParams = {},
  customHeaders = {}
) {
  return api
    .post(
      '/oauth/token',
      stringify({
        username,
        password,
        grant_type: 'password',
        ...aditionalParams,
      }),
      {
        headers: {
          [_getChar(0) +
          _getChar(1) +
          _getChar(2) +
          _getChar(3) +
          _getChar(4) +
          _getChar(5) +
          _getChar(6) +
          _getChar(7) +
          _getChar(8) +
          _getChar(9) +
          _getChar(10) +
          _getChar(11) +
          _getChar(12)]: `${
            _getAChar(0) +
            _getAChar(1) +
            _getAChar(2) +
            _getAChar(3) +
            _getAChar(4)
          } ${_getKeyValue(0)}`,
          'Content-Type': 'application/x-www-form-urlencoded',
          ...customHeaders, // Merge custom headers here
        },
        notify: false,
      }
    )
    .then((response) => {
      response.expires_at = moment()
        .add(response.expires_in - 10, 's')
        .unix()
      return response
    })
}

export function logoutApi() {
  return api.post('/user/logout', {
    notify: false,
  })
}

export function getUserApi() {
  return api
    .get(`${isPortalLogin() ? '/requester' : '/technician'}/me`)
    .then(transformUser)
}

export function getClientIdApi(fingerprint) {
  return api
    .post(
      '/public/session/register',
      {
        fingerPrint: getEncryptedPassword(fingerprint),
      },
      {
        headers: {
          Authorization: null,
        },
      }
    )
    .then((response) => response)
}

export function getUserProfileApi() {
  return api.get('/user/profile').then((data) => {
    return {
      securityQuestions: (data.securityQuestions || []).map((m) => {
        return {
          id: m.id,
          name: m.key,
        }
      }),
      displaySecurityPopup: data.displaySecurityPopup,
    }
  })
}

export function updateUserProfileApi(data) {
  return api.patch('/user/profile', data).then((data) => {
    return {
      securityQuestions: data.securityQuestions,
    }
  })
}

export function changePasswordApi(data) {
  const __rootT = getRootTranslator()
  return api.post(
    '/user/changepassword/',
    {
      currentPassword: data.currentPassword,
      password: data.password,
    },
    {
      message: __rootT('updated_successfully', {
        resource: __rootT('password'),
      }),
    }
  )
}
